module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjRweCIgdmlld0JveD0iMCAwIDI0IDI0IiB3aWR0aD0iMjRweCIgZmlsbD0iIzAwMDAwMCI+PHBhdGggZD0iTTAgMGgyNHYyNEgwVjB6IiBmaWxsPSJub25lIi8+PHBhdGggZD0iTTIxIDcuMjhWNWMwLTEuMS0uOS0yLTItMkg1Yy0xLjExIDAtMiAuOS0yIDJ2MTRjMCAxLjEuODkgMiAyIDJoMTRjMS4xIDAgMi0uOSAyLTJ2LTIuMjhjLjU5LS4zNSAxLS45OCAxLTEuNzJWOWMwLS43NC0uNDEtMS4zNy0xLTEuNzJ6TTIwIDl2NmgtN1Y5aDd6TTUgMTlWNWgxNHYyaC02Yy0xLjEgMC0yIC45LTIgMnY2YzAgMS4xLjkgMiAyIDJoNnYySDV6Ii8+PGNpcmNsZSBjeD0iMTYiIGN5PSIxMiIgcj0iMS41Ii8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_wallet.svg
// module id = 32gV
// module chunks = 4